import React from 'react';

const Actions = ({data, setEditData, setIsPopupOpen}) => {
  const handleEdit = () => {
    setEditData(data);
    setIsPopupOpen(true);
  };

  return (
    <div className='actions-container'>
      <button className='btn btn-danger btn-sm delete' onClick={handleEdit}>
        <i className='bi bi-pencil'></i> Edit
      </button>
    </div>
  );
};

export default Actions;
